module.exports = __webpack_public_path__ + "img/gc_country_flag_sm.4b4c8fec.svg";